import { render, staticRenderFns } from "./LegacyContentAdminSearch.vue?vue&type=template&id=94d9864c"
import script from "./LegacyContentAdminSearch.vue?vue&type=script&lang=js"
export * from "./LegacyContentAdminSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports